import { HomePhoneFeature } from "../../../../types/homePhone";

export const DEFAULT_FEATURES: readonly HomePhoneFeature[] = [
  { label: "2 FXS phone ports" },
  { label: "Supports analog phones" },
  { label: "VoIP to analog conversion" },
  { label: "Works with SIP service" },
  { label: "Easy home phone setup" },
  { label: "Compact adapter" },
];

const PRODUCT_DETAIL = {
  LABELS: {
    PRICE_UNIT: "/ unit",
    SPEC_TITLE: "Key Specifications",
    CTA: "Get This Device",
  },
} as const;

export default PRODUCT_DETAIL;
